import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../Widgets/LabeledSelect";
import { DepressionScreeningFormValues } from "./interface";

interface EditFieldsProps {
  formValues: DepressionScreeningFormValues;
  handleChange: (
    field: keyof DepressionScreeningFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const YES_NO_UNKNOWN_NA_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
  { value: "UNKNOWN", label: "Unknown" },
  { value: "NOT_APPLICABLE", label: "Not Applicable" },
];

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="During the past month, the client has been bothered by feeling down, depressed, or hopeless."
        value={formValues.feelingDown}
        onChange={handleChange("feelingDown")}
        options={YES_NO_UNKNOWN_NA_OPTIONS}
      />
      <LabeledSelect
        label="During the past month, the client has been bothered by little interest or pleasure in doing things?"
        value={formValues.littleInterest}
        onChange={handleChange("littleInterest")}
        options={YES_NO_UNKNOWN_NA_OPTIONS}
      />
    </Grid>
  );
};

export default EditFields;
